// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Button } from '@mui/material';
import { createLink } from '@tanstack/react-router';

/**
 * A styled button component for navigating within the application.
 */
export const LinkedButton = createLink(Button);
